import { Button, Typography } from "@mui/material";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { excelExtensions, fileTypes, imageExtensions, pdfExtensions, } from "../genericFileUpload/genericFileUploadTypes";
import { openPopup } from "../../stateManagement/actions/popupActions";
import pdfIcon from "../../images/PDF.png";
import pptIcon from "../../images/PPT.png";
import excelIcon from "../../images/XLS.png";
import { Loader } from "../loader/Loader";
import defaultFileIcon from "../../images/defaultFileIcon.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faXmark } from "@fortawesome/free-solid-svg-icons";
import { uploadImages } from "../../services/bannerServices";

export const UiConfigImageUpload = (props: any) => {
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [acceptAttribute, setAcceptAttribute] = useState<string>("");
    const [imageDisplayIcon, setImageDisplayIcon] = useState<string>("");
    const [fileName, setFileName] = useState<string>("");
    const imgRef = useRef<HTMLImageElement | null>(null);
    const [imageLoading, setImageLoading] = useState<boolean>(false);
    useEffect(() => {
        let finalAcceptAttribute = "";
        for (let fileTypeAttribute in props.accept) {
            const tempArray = props.accept[fileTypeAttribute as fileTypes];
            if (tempArray) {
                for (const fileExtensionType of tempArray) {
                    finalAcceptAttribute += (fileTypeAttribute + "/" + fileExtensionType + ", ");
                }
            }
        }
        setAcceptAttribute(finalAcceptAttribute);
        if (props.defaultFile) {
            const splitArray = props.defaultFile.split(".");
            const extension = splitArray[splitArray.length - 1];
            if (imageExtensions.includes(extension)) {
                setImageDisplayIcon(props.defaultFile);
            } else if (pdfExtensions.includes(extension)) {
                setImageDisplayIcon(pdfIcon);
            } else if (excelExtensions.includes(extension)) {
                setImageDisplayIcon(excelIcon);
            } else {
                setImageDisplayIcon(props.defaultFile);
            }
        }
    }, [props.defaultFile])
    const validateImageAndUpload = async (file: File | undefined) => {
        if (file) {
             if (props.maxSizeKB && file.size / 1024 > props.maxSizeKB) {
      openPopup("Alert", `File size must be less than ${props.maxSizeKB} KB. Your file size is ${(file.size / 1024).toFixed(2)} KB.`);
      return;
    }
            let fileType = file.type.split('/')[0] as fileTypes;
            let fileExtension = file.type.split("/")[1];
            const temp = props.accept[fileType] as string[];
            let isValidExtension = true;
            if (fileType !== "image" && !temp.includes("*")) {
                isValidExtension = temp.includes(fileExtension);
            }
            if (!isValidExtension) {
                openPopup("Alert", `File with ${fileExtension} extension is not valid`);
                return;
            }
            if (!props.fetchBlobKey) {
                if (file.type === "application/pdf") {
                    setImageDisplayIcon(pdfIcon);
                    if (props.setFile) props.setFile(file);
                    if (props.setDefaultFile) props.setDefaultFile("");
                    setFileName(file.name);
                } else if (
                    file.type ===
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                    file.type === "text/csv" ||
                    file.type === "application/vnd.ms-excel"
                ) {
                    setImageDisplayIcon(excelIcon);
                    if (props.setFile) props.setFile(file);
                    if (props.setDefaultFile) props.setDefaultFile("");
                    setFileName(file.name);
                    if (props.setFileAttributes) props.setFileAttributes({ fileName: file.name, fileType: file.type });
                } else if (
                    file.type ===
                    "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
                    file.type === "application/vnd.ms-powerpoint"
                ) {
                    setImageDisplayIcon(pptIcon);
                    if (props.setFile) props.setFile(file);
                    if (props.setDefaultFile) props.setDefaultFile("");
                    setFileName(file.name);
                    if (props.setFileAttributes) props.setFileAttributes({ fileName: file.name, fileType: file.type });
                } else if (fileType === "image") {
                    if (props.resolution) {
                        let img = new Image();
                        let objectUrl = URL.createObjectURL(file);
                        img.onload = function (evt) {
                            if (!props.max && (img.naturalHeight !== props.resolution.height || img.naturalWidth !== props.resolution.width)) {
                                openPopup("Alert", "image resolution mustt be " + props.resolution.width + "X" + props.resolution.height + ", your image resolution is " + img.naturalWidth + "X" + img.naturalHeight)
                            }else if (props.max && (img.naturalHeight > props.resolution.height || img.naturalWidth > props.resolution.width)) {
                                openPopup("Alert", "image resolution must be less than " + props.resolution.width + "X" + props.resolution.height + ", your image resolution is " + img.naturalWidth + "X" + img.naturalHeight)
                            } else {
                                if (props.setFile) props.setFile(file);
                                if (props.setDefaultFile) props.setDefaultFile("");
                                setImageDisplayIcon(objectUrl);
                                setFileName(file.name);
                                if (props.setFileAttributes) props.setFileAttributes({ fileName: file.name, fileType: file.type });
                            }
                        };
                        img.src = objectUrl;
                    } else {
                        if (props.setFile) props.setFile(file);
                        if (props.setDefaultFile) props.setDefaultFile("");
                        setImageDisplayIcon(URL.createObjectURL(file));
                        setFileName(file.name);
                        if (props.setFileAttributes) props.setFileAttributes({ fileName: file.name, fileType: file.type });
                    }
                }
            } else {// if fetchBlobkey = true
                setImageLoading(true);
                if (fileType === "image") {
                    if (props.resolution) {
                        let img = new Image();
                        let objectUrl = URL.createObjectURL(file);
                        img.onload = async function (evt) {
                            if (!props.max && (img.naturalHeight !== props.resolution.height || img.naturalWidth !== props.resolution.width)) {
                                setImageLoading(false);
                                openPopup("Alert", "image resolution must be " + props.resolution.width + "X" + props.resolution.height + ", your image resolution is " + img.naturalWidth + "X" + img.naturalHeight)
                            }else if (props.max && (img.naturalHeight > props.resolution.height || img.naturalWidth > props.resolution.width)) {
                                setImageLoading(false);
                                openPopup("Alert", "image resolution must be less than" + props.resolution.width + "X" + props.resolution.height + ", your image resolution is " + img.naturalWidth + "X" + img.naturalHeight)
                            } else {
                                const fileData = new FormData();
                                fileData.append("files", file);
                                const blobUrlResponse = fileData.has('files') ? await uploadImages(fileData) : [];
                                if (!Array.isArray(blobUrlResponse)) {
                                    setImageLoading(false);
                                    openPopup("Error", blobUrlResponse.message);
                                    return;
                                }
                                // props.setFile(file);
                                if (props.setDefaultFile) props.setDefaultFile(blobUrlResponse[0]);
                                setImageDisplayIcon(blobUrlResponse[0]);
                                setImageLoading(false);
                                setFileName(file.name);
                                if (props.setFileAttributes) props.setFileAttributes({ fileName: file.name, fileType: file.type });
                            }
                        };
                        img.src = objectUrl;
                    } else {
                        const fileData = new FormData();
                        fileData.append("files", file);
                        const blobUrlResponse = fileData.has('files') ? await uploadImages(fileData) : [];
                        if (!Array.isArray(blobUrlResponse)) {
                            setImageLoading(false);
                            openPopup("Error", blobUrlResponse.message);
                            return;
                        }
                        if (props.setDefaultFile) props.setDefaultFile(blobUrlResponse[0]);
                        setImageDisplayIcon(blobUrlResponse[0]);
                        setImageLoading(false);
                    }
                } else {
                    const fileData = new FormData();
                    fileData.append("files", file);
                    const blobUrlResponse = fileData.has('files') ? await uploadImages(fileData) : [];
                    if (!Array.isArray(blobUrlResponse)) {
                        setImageLoading(false);
                        openPopup("Error", blobUrlResponse.message);
                        return;
                    }
                    if (file.type === "application/pdf") {
                        setImageDisplayIcon(pdfIcon);
                    } else if (
                        file.type ===
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                        file.type === "text/csv" ||
                        file.type === "application/vnd.ms-excel"
                    ) {
                        setImageDisplayIcon(excelIcon);
                    } else if (
                        file.type ===
                        "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
                        file.type === "application/vnd.ms-powerpoint"
                    ) {
                        setImageDisplayIcon(pptIcon);
                    } else {
                        setImageDisplayIcon(blobUrlResponse[0])
                    }
                    if (props.setDefaultFile) props.setDefaultFile(blobUrlResponse[0]);
                    setFileName(file.name);
                    if (props.setFileAttributes) props.setFileAttributes({ fileName: file.name, fileType: file.type });
                    setImageLoading(false);
                }
            }

        }
    }
    const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target?.files) {
            validateImageAndUpload(event.target.files?.[0]);
        }
    }
    const handleClick = () => {
        if (fileInputRef.current) {
            if (!props.fetchBlobKey) fileInputRef.current.value = "";
            if (!imageLoading) fileInputRef.current.click();
            if (props.setFile && props.file) props.setFile(null);
            if (!props.fetchBlobKey && props.setFileAttributes && props.fileAttributes) props.setFileAttributes({ fileName: "", fileType: "" });
        }
    }
    const handleCrossButton = () => {
        if (props.file) {
            if (props.setFile && props.file) props.setFile(null);
        }
        if (props.defaultFile && props.setDefaultFile) {
            props.setDefaultFile("");
        }
    }
    return (
        <div className="generic_form_container" style={props.list ? { flexDirection: "column", gap: "10px" } : {}}>
            <div className="generic-file-upload-container" style={{ width: props.list ? "10rem" :"12rem", height: props.list ? "6.5rem" :"7.5rem", backgroundColor: "#F5F5F5", borderColor: "grey", color: "#1C7EA0" }}>
                <div className="generic-file-upload"
                    onClick={handleClick}
                >

                    {imageLoading ? <Loader /> : (props.file ? (
                        <>
                            <img
                                src={imageDisplayIcon}
                                height="45"
                                width="auto"
                                alt="banner preview"
                            />
                            <span style={{ fontSize: "14px" }}> {props.label}</span>
                        </>
                    ) : props.defaultFile ? (
                        <>
                            <img
                                src={imageDisplayIcon}
                                height="45"
                                width="auto"
                                ref={imgRef}
                                onError={() => {
                                    if (imgRef.current)
                                        imgRef.current.src = defaultFileIcon;
                                }}
                                alt="banner preview"
                            />
                            <span style={{ fontSize: "14px" }}> {props.label}</span>
                        </>
                    ) : (
                        <>
                            <FontAwesomeIcon icon={faCamera} style={{ width: "2.5rem", height: "2.8rem" }} />
                            <span style={{ fontSize: "14px" }}> {props.label}</span>
                        </>
                    ))}
                    <input
                        type="file"
                        onChange={handleImageUpload}
                        hidden
                        accept={acceptAttribute}
                        ref={fileInputRef}
                    />
                </div>
            </div>
            {!props.list && <span className="resolution_text">*The {props.max ? "maximum": ""} image resolution should be {props.resolution.width}X{props.resolution.height}</span>}
            
            <Button  style={props.list ? { fontSize:"0.7rem" } : {}} variant="contained" onClick={handleCrossButton}>Remove Image</Button>
        </div>
    )

}

